import http from './HttpService'
import { API_BASE_URL_ENV } from "../jsx/common/common";
import BaseService from './BaseService';

const apiPostEndpoint = API_BASE_URL_ENV() + "/subCategories/addSubCategory";
const apiGetEndpoint = API_BASE_URL_ENV() + "/subCategories/getSubCategory";
const apiGetSubForCategoryEndpoint = API_BASE_URL_ENV() + "/subCategories/getSubCategoryOfCategory";
const apiDeleteEndpoint = API_BASE_URL_ENV() + "/subCategories/deleteSubCategory";
const apiUpdateEndpoint = API_BASE_URL_ENV() + "/subCategories/updateSubCategory";

export default class SubCategoriesService extends BaseService {
    
    getList(params) {
        if(params){
            return http.get(apiGetEndpoint,{params});
        }
        return http.get(apiGetEndpoint);
    }

    getListForCategory(id) {
        return http.get(`${apiGetSubForCategoryEndpoint}/${id}`);
    }

    create(data) {
        return http.post(apiPostEndpoint, data);
    }

    remove(id) {
        return http.delete(`${apiDeleteEndpoint}/${id}`);
    }
    
    update(id, data) {
        const body = { ...data };
        return http.put(`${apiUpdateEndpoint}/${id}`, body);
    }
   
}
